import forexLogo from "@app/assets/images/logo-home.svg";
import { LogoutModal, Modal } from "@app/components";
import { Button } from "@app/controls";
import type { RootState } from "@app/redux";
import React from "react";
import { useSelector } from "react-redux";
import messages from "./messages";
import type { ViewProperties } from "./properties";
import "./welcome-modal.css";
import "./welcome-modal.responsive.css";

export const WelcomeModalView = React.memo((props: ViewProperties) => {
	const { language } = useSelector((state: RootState) => state.language);

	return (
		<>
			{props.showLogoutModal && (
				<LogoutModal open onClose={props.onCloseLogoutModal} />
			)}
			<Modal
				className="welcome-modal"
				open={props.open}
				noCloseButton
				overlayColor="light"
			>
				<img src={forexLogo} alt="forex logo" />
				<div
					className="my-12"
					dangerouslySetInnerHTML={{
						__html: messages[language].body,
					}}
				></div>
				<div className="flex justify-center mx-auto">
					<Button
						className="w-full font-primary-medium text-lg"
						type="button"
						theme="tertiary"
						onClick={props.onLogout}
					>
						{messages[language].logout}
					</Button>
					<Button
						className="w-full mx-1"
						type="button"
						theme="primary"
						onClick={props.onProceed}
					>
						{messages[language].proceed}
					</Button>
				</div>
			</Modal>
		</>
	);
});
